var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex w-full flex-col"},[_c('div',[_c('global-uploader-button',{attrs:{"label":_vm.labelAction}})],1),_c('div',{staticClass:"w-full"},[_c('global-uploader-item',{on:{"clickFile":_vm.clickFile}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }